import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererDraftBlocksApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getBlockSchemas = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/block_schemas/draft_sections/${pathParams.id}`);
        };
        this.getBlockSection = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/drafts/blocks/sections/${pathParams.section_id}`);
        };
        this.createBlock = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/blocks`, requestBody);
        };
        this.updateBlock = (pathParams, requestBody) => {
            return this.put(`/shops/${pathParams.shop_id}/drafts/blocks/${pathParams.draft_block_id}`, requestBody);
        };
        this.reorderBlock = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/drafts/blocks/${pathParams.draft_block_id}/reorder`, requestBody);
        };
        this.removeBlock = (pathParams) => {
            return this.delete(`/shops/${pathParams.shop_id}/drafts/blocks/${pathParams.draft_block_id}`);
        };
    }
}
export const ShopRendererDraftBlocksApiClient = new ShopRendererDraftBlocksApiClientModel(getShopRendererApiUrl('api'));
